import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, isRef as _isRef, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34e3807a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("服务"),
  /*#__PURE__*/_createElementVNode("span", { class: "theme-word" }, "40万"),
  /*#__PURE__*/_createTextVNode("教培机构")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("为"),
  /*#__PURE__*/_createElementVNode("span", { class: "theme-word" }, "4亿"),
  /*#__PURE__*/_createTextVNode("孩子和成人的教育成长保驾护航")
], -1))
const _hoisted_4 = { class: "second-part" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "third-part" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vertical-line" }, "NEW", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }, null, -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "更多", -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<section class=\"fourth-part\" data-v-34e3807a><div class=\"container\" data-v-34e3807a><article class=\"public-style\" data-v-34e3807a><h1 data-v-34e3807a>company introduction</h1><h3 class=\"theme-word\" data-v-34e3807a>公司介绍</h3><p data-v-34e3807a> 南京八爪教育科技有限公司隶属于创新国际集团，深耕行业20年，积累了丰富的营销推广经验，业务范围覆盖全国29个省，200多家分公司，7000多名线下全职推广人员，拥有非常丰富的实战营销经验，做教育以来，秉承“为家长指明路、为教培添新路”的文化理念，专注于为教培机构提供拓客地推、线上线下引流、转化续费、企业落地营销、管理培训、招生管理托管和平台推广等一站式营销服务。 </p><p data-v-34e3807a>目前营销范围涵盖素质教育全品类，招生领域包含：艺术类、音乐类、体育类、科技类、研学营地类等。未来，将会将服务范围拓展至教育全领域。目标：服务40万家教培机构，成就4亿孩子和成年人的教育成长。</p></article><aside data-v-34e3807a><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/octopus/p401.jpg\" data-v-34e3807a><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/octopus/p402.jpg\" data-v-34e3807a></aside></div></section>", 1)
const _hoisted_13 = { class: "fifth-part" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "public-style" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "history OF development", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "theme-word" }, "发展历程", -1))
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "slither" }
const _hoisted_20 = { class: "sixth-part" }
const _hoisted_21 = { class: "public-style container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Who we serve", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "theme-word" }, "我们的服务对象", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "word" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "教培机构"),
  /*#__PURE__*/_createElementVNode("p", null, "通过双模式招生营销平台，帮助机构获客、运营、增收")
], -1))
const _hoisted_25 = {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/phoneTwo.png",
  alt: "教培机构",
  ref: "servePic"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "word" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "white" }, "家长/孩子"),
  /*#__PURE__*/_createElementVNode("p", { class: "white" }, "帮助家长发现身边的好机构，助力孩子五育培养、升学成长")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/phoneOne.png",
  alt: "家长/孩子"
}, null, -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "seventh-part" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container public-style" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Our service team"),
  /*#__PURE__*/_createElementVNode("h3", { class: "theme-word" }, "我们的服务团队")
], -1))
const _hoisted_31 = { class: "swiper" }
const _hoisted_32 = { class: "swiper-container swiper-team" }
const _hoisted_33 = { class: "swiper-wrapper" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "address" }
const _hoisted_36 = { class: "eighth-part" }
const _hoisted_37 = { class: "container public-style" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<h1 data-v-34e3807a>Our partners</h1><h3 class=\"theme-word\" data-v-34e3807a>我们的合作伙伴</h3><div class=\"ring c1568\" data-v-34e3807a><div class=\"ring c1232\" data-v-34e3807a><div class=\"ring c902\" data-v-34e3807a><div class=\"ring c572\" data-v-34e3807a><div class=\"ring center\" data-v-34e3807a><h1 class=\"theme-word\" data-v-34e3807a>400000+</h1><h3 data-v-34e3807a>教育机构的共同选择</h3></div></div></div></div></div>", 3)
const _hoisted_41 = { class: "partners" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "on-mobile" }
const _hoisted_44 = { class: "swiper" }
const _hoisted_45 = { class: "swiper-container swiper-banner" }
const _hoisted_46 = { class: "swiper-wrapper" }
const _hoisted_47 = {
  key: 0,
  class: "first-pic"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("服务"),
    /*#__PURE__*/_createElementVNode("span", { class: "theme-word" }, "40万"),
    /*#__PURE__*/_createTextVNode("教培机构")
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "theme-word" }, "4亿"),
    /*#__PURE__*/_createTextVNode("孩子和成人的教育成长保驾护航")
  ])
], -1))
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<section class=\"introduce\" data-v-34e3807a><div class=\"container\" data-v-34e3807a><div class=\"title\" data-v-34e3807a>公司介绍</div><div class=\"content\" data-v-34e3807a><p data-v-34e3807a> 南京八爪教育科技有限公司隶属于创新国际集团，深耕行业20年，积累了丰富的营销推广经验，业务范围覆盖全国29个省，200多家分公司，7000多名线下全职推广人员，拥有非常丰富的实战营销经验，做教育以来，秉承“为家长指明路、为教培添新路”的文化理念，专注于为教培机构提供拓客地推、线上线下引流、转化续费、企业落地营销、管理培训、招生管理托管和平台推广等一站式营销服务。 </p><p data-v-34e3807a>目前营销范围涵盖素质教育全品类，招生领域包含：艺术类、音乐类、体育类、科技类、研学营地类等。未来，将会将服务范围拓展至教育全领域。目标：服务40万家教培机构，成就4亿孩子和成年人的教育成长。</p></div><div class=\"picture clearfix\" data-v-34e3807a><img class=\"fl\" src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/octopus/p401.jpg\" alt=\"总裁\" data-v-34e3807a><img class=\"fr\" src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/octopus/p402.jpg\" alt=\"领奖\" data-v-34e3807a></div></div></section>", 1)
const _hoisted_53 = { class: "course" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发展历程")
], -1))
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<section class=\"object\" data-v-34e3807a><div class=\"container\" data-v-34e3807a><div class=\"title\" data-v-34e3807a>我们的服务对象</div><div class=\"picture\" data-v-34e3807a><article data-v-34e3807a><div data-v-34e3807a><h1 data-v-34e3807a>教培机构</h1><p data-v-34e3807a>通过双模式招生营销平台，</p><p data-v-34e3807a>帮助机构获客、运营、增收</p></div><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/phoneTwo.png\" alt=\"教培机构\" data-v-34e3807a></article><article data-v-34e3807a><div class=\"white\" data-v-34e3807a><h1 data-v-34e3807a>家长/孩子</h1><p data-v-34e3807a>帮助家长发现身边的好机构，</p><p data-v-34e3807a>助力孩子五育培养、升学成长</p></div><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/phoneOne.png\" alt=\"家长/孩子\" data-v-34e3807a></article></div></div></section>", 1)
const _hoisted_57 = { class: "group" }
const _hoisted_58 = { class: "container" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我们的服务团队", -1))
const _hoisted_60 = { class: "swiper" }
const _hoisted_61 = { class: "swiper-container swiper-phone-team" }
const _hoisted_62 = { class: "swiper-wrapper" }
const _hoisted_63 = { class: "right" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev flip" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next flip" }, null, -1))
const _hoisted_66 = { class: "partners" }
const _hoisted_67 = { class: "container" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我们的合作伙伴", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "theme-word" }, "400000+"),
  /*#__PURE__*/_createTextVNode("教育机构的共同选择")
], -1))
const _hoisted_70 = { class: "picture clearfix" }

import { useRouter } from "vue-router";
import { splitArrayIntoChunks } from "@/utils/tools";
import { historyListHttp, partnerListHttp, newsListHttp, serveListHttp } from "@/request/api";
import { ref, onMounted, onUnmounted } from 'vue';
import { computed } from "@vue/reactivity";
import { newsPicList } from "@/utils/global";
import Swiper, { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/swiper.min.css"; // 整个轮播图的样式
// swiper-bundle.min.css 决定了小圆点和左右翻页标签，如果不需要可以不引用
import "swiper/swiper-bundle.min.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'octopus',
  setup(__props) {

// 引入useRouter
Swiper.use([Autoplay, Pagination, Navigation]);

// 目录点击跳转路由事件
const router = useRouter();

// 服务对象
let hoverFlag = ref(true);

// 服务团队
const teamList = ref<any>([]);// PC端-一页8个
const teamPhoneList = ref<any>([]);// 移动端-一页4个
serveListHttp({
  page: 1,
  limit: 100
}).then((res: any) => {
  let { page } = res;
  let { list } = page;
  teamList.value = splitArrayIntoChunks(list, 8);
  teamPhoneList.value = splitArrayIntoChunks(list, 4);
})

// 发展历程
const developments = ref([] as any[]);
let devLength = ref(0);
historyListHttp({
  title: "",
  page: 1,
  limit: 100
}).then((res: any) => {
  let { page } = res;
  let { list } = page;
  developments.value = list;
  devLength.value = list.length;
})
// 发展历程位置
const dragNumber = ref<number>(0);
let devLeft = computed(() => {
  let left = ((devLength.value * 20) - 80) / 100 * dragNumber.value;
  return `-${left}vw`;
});

// 合作伙伴
let partners = ref([] as any[]); // 移动端
let allPartners = ref([] as any[]); // PC端
let page = ref(0);
let hasMore = ref(true);

const getPartnerList = () => {
  page.value += 1;
  partnerListHttp({
    page: page.value,
    limit: 8
  }).then((res: any) => {
    let { page } = res;
    let { list, pageSize } = page;
    partners.value = partners.value.concat(list);
    hasMore.value = list.length == pageSize;
  })
}
getPartnerList()
const getAllPartnerList = () => {
  partnerListHttp({ page: 1, limit: 26 }).then((res: any) => {
    let { page } = res;
    let { list } = page;
    allPartners.value = list;
  })
}
getAllPartnerList()

// 新闻列表
const newsList = ref([] as any[]);
newsListHttp({
  title: "",
  newsType: "",
  page: 1,
  limit: 4,
  year: ""
}).then((res: any) => {
  let { page } = res;
  let { list } = page;
  newsList.value = list;
})

const toNewsDetail = (id: any) => {
  router.push({ name: "newsDetail", query: { id } });
}
// 定位到新闻
const toNewsPart = () => {
  let top = document.documentElement.scrollTop; //获取点击时页面的滚动条纵坐标位置
  const timeDown = setInterval(() => {
    document.documentElement.scrollTop = top += 50; //一次滑动50
    if (top >= 1050) {
      clearInterval(timeDown);
    }
  }, 5)//定时调用函数使其更顺滑
}

// 移动端-发展历程
const devPhDom = ref<HTMLElement | null>(null);
const devPhPro = ref<HTMLElement | null>(null);
let devPhLeft = ref(0);
const handleScroll = () => {
  if (devPhDom.value && devPhPro.value) {
    let a = devPhDom.value.scrollLeft;// 卷曲的宽度
    let b = devPhDom.value.scrollWidth - devPhDom.value.clientWidth;// 总宽减去视宽
    let c = devPhPro.value.clientWidth * 0.9;// 可滚动长
    devPhLeft.value = a / b * c;
  }
};
// 挂载后
onMounted(() => {
  var timer = setTimeout(() => {
    // PC端-我们的服务团队
    new Swiper(".swiper-team", {
      loop: true, // 循环
      speed: 18000, //切换过渡速度
      freeMode: true,
      autoplay: {
        delay: 0, //多少秒切换一次
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      slidesPerView: "auto", //解决最后一张切换到第一张中间的空白
      observeParents: false,   //必须加入
      observer: true, //必须加入
    });
    clearTimeout(timer)
  }, 100)

  // 移动端-banner
  new Swiper(".swiper-banner", {
    loop: true, // 循环
    speed: 1000, //切换过渡速度
    pagination: {
      el: ".swiper-pagination",
    },
    autoplay: {
      delay: 2000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  });

  // 移动端-发展历程-监听滚动事件
  devPhDom.value && devPhDom.value.addEventListener('scroll', handleScroll);

  // 移动端-我们的服务团队
  new Swiper(".swiper-phone-team", {
    loop: false, // 循环
    speed: 1000, //切换过渡速度
    slidesPerView: 1.1,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
  });
})
// 卸载后
onUnmounted(() => {
  // 移动端-发展历程-移除监听事件
  devPhDom.value && devPhDom.value.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", { class: "first-part" }, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          class: "to-news",
          onClick: toNewsPart
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_el_carousel, {
          height: "800px",
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsPicList), (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item,
                    class: "loop-pic"
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(item.publishTime), 1),
                _hoisted_8
              ]),
              _hoisted_9,
              _createElementVNode("p", {
                class: "content",
                onClick: ($event: any) => (toNewsDetail(item.id))
              }, _toDisplayString(item.title), 9, _hoisted_10)
            ]))
          }), 128)),
          _createVNode(_component_router_link, { to: { name: 'newsList' } }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_12,
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("article", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("ul", {
              style: _normalizeStyle('left: ' + _unref(devLeft))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(developments.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", null, _toDisplayString(item.occurrenceTime), 1),
                    _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                    _createElementVNode("p", null, _toDisplayString(item.subtitle), 1)
                  ]),
                  _createElementVNode("img", {
                    src: item.imgUrl,
                    alt: item.title
                  }, null, 8, _hoisted_18)
                ]))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_slider, {
              modelValue: dragNumber.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dragNumber).value = $event)),
              step: 0.1,
              "show-tooltip": false,
              disabled: _unref(devLength) <= 0
            }, null, 8, ["modelValue", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("article", null, [
            _createElementVNode("aside", {
              class: _normalizeClass({ active: _unref(hoverFlag) }),
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_isRef(hoverFlag) //@ts-ignore
 ? hoverFlag.value = true : hoverFlag = true))
            }, [
              _hoisted_24,
              _createElementVNode("img", _hoisted_25, null, 512)
            ], 34),
            _createElementVNode("aside", {
              class: _normalizeClass({ active: !_unref(hoverFlag) }),
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_isRef(hoverFlag) //@ts-ignore
 ? hoverFlag.value = false : hoverFlag = false))
            }, _hoisted_28, 34)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamList.value, (list, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "swiper-slide swiper-team-each",
                  key: key
                }, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("img", {
                          src: item.imgUrl,
                          alt: item.name,
                          class: "pr"
                        }, null, 8, _hoisted_34),
                        _createElementVNode("div", _hoisted_35, _toDisplayString(item.coordinates), 1),
                        _createElementVNode("h1", null, _toDisplayString(item.name), 1),
                        _createElementVNode("p", null, _toDisplayString(item.classification), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allPartners), (item, i) => {
              return (_openBlock(), _createElementBlock("img", {
                key: i,
                src: item.imgUrl
              }, null, 8, _hoisted_42))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("section", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsPicList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "swiper-slide",
                key: index
              }, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("img", {
                        src: item,
                        class: "loop-pic"
                      }, null, 8, _hoisted_49)
                    ]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: item,
                      class: "loop-pic"
                    }, null, 8, _hoisted_50))
              ]))
            }), 128))
          ]),
          _hoisted_51
        ])
      ]),
      _hoisted_52,
      _createElementVNode("section", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("ul", {
          class: "dev-progress",
          ref_key: "devPhDom",
          ref: devPhDom
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(developments.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "dev-each",
              key: index
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", null, _toDisplayString(item.occurrenceTime), 1),
                _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", null, _toDisplayString(item.subtitle), 1)
              ]),
              _createElementVNode("img", {
                src: item.imgUrl
              }, null, 8, _hoisted_55)
            ]))
          }), 128))
        ], 512),
        _createElementVNode("div", {
          class: "scroll-progress",
          ref_key: "devPhPro",
          ref: devPhPro
        }, [
          _createElementVNode("i", {
            style: _normalizeStyle('left:' + _unref(devPhLeft) + 'px')
          }, null, 4)
        ], 512)
      ]),
      _hoisted_56,
      _createElementVNode("section", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamPhoneList.value, (list, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "swiper-slide swiper-team-phone-each",
                    key: key
                  }, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", {
                            class: "address",
                            style: _normalizeStyle('background-image: url(' + item.imgUrl + ')')
                          }, [
                            _createElementVNode("span", null, _toDisplayString(item.coordinates), 1)
                          ], 4),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("h1", null, _toDisplayString(item.name), 1),
                            _createElementVNode("p", null, _toDisplayString(item.classification), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]),
              _hoisted_64,
              _hoisted_65
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partners), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fl",
                key: index,
                style: _normalizeStyle('background-image:url(' + item.imgUrl + ')')
              }, null, 4))
            }), 128))
          ]),
          (_unref(hasMore))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "more",
                onClick: getPartnerList
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})